import * as React from 'react'
import {
    ActionButton,
    DefaultButton,
    Dialog,
    DialogFooter,
    DialogType,
    Dropdown,
    PrimaryButton,
    Checkbox,
    ChoiceGroup,
    IChoiceGroupOption,
    IDropdownOption,
  } from "office-ui-fabric-react";
  import { connect } from "react-redux";
import axios from 'axios';
import { ROOT_URL, SP_HOST_URL } from '../../actions/constants';

  export interface IClassStudentSelectorProps {
    dialogTitle:string;
    selWeek:string;
    selYear:string;
    teacherstate: any;
    onDialogDismiss: () => void;
  }

  export interface IClassStudentSelectorState {
    selType:string;
    optionsType:IChoiceGroupOption[];
    selClassID:string;
    selStudentID:string;
    selStudentName:string;
    optionsClasses:IDropdownOption[];
    optionsStudents:IDropdownOption[];
    isLoadingStudents:boolean;
  }

  class ClassStudentSelector extends React.Component<
    IClassStudentSelectorProps,
    IClassStudentSelectorState
  > {

    componentDidMount() {
      const classes = [];
      
      Object.keys(this.props.teacherstate.subscribedSchoolClasses).forEach((c)=>{
        classes.push({key:this.props.teacherstate.subscribedSchoolClasses[c].ClassID,text:this.props.teacherstate.subscribedSchoolClasses[c].ClassName});
      });
      
      this.setState(
        {
          optionsType:[{key:"CLASS",text:"Klasse"},{key:"STUDENT",text:"Elev"}],
          selType: "CLASS",
          selClassID:"",
          selStudentID:"",
          selStudentName:"",
          optionsClasses:classes,
          optionsStudents:[],
          isLoadingStudents:false
        });
    }

    getStudentsForClass(classId:string) {
      this.setState({selStudentName:"",selStudentID:"",optionsStudents:[],isLoadingStudents:true});
      const data = {ClassID:classId}
      axios.post(`${ROOT_URL}/GetStudents/${SP_HOST_URL}`, data, {
        headers: {
          Authorization: localStorage.getItem("id_token"),
        },
      }).then((response) => {
        this.setState({optionsStudents:response.data.map((s)=> {return {key:s.LoginName,text:s.Name}}),isLoadingStudents:false});
      });
    }

    render() {
      return !!this.state && (
        <Dialog
            hidden={false}
            onDismiss={this.props.onDialogDismiss}
            dialogContentProps={{
              type: DialogType.normal,
              title: this.props.dialogTitle,
              subText: ""
            }}
            styles={{
              main: [
                {
                  selectors: {
                    ["@media (min-width: 480px)"]: {
                      maxWidth: "600px",
                      minWidth: "480px"
                    }
                  }
                }
              ]
            }}
            modalProps={{
              titleAriaId: "myLabelId",
              subtitleAriaId: "mySubTextId",
              isBlocking: true,
              containerClassName: "ms-dialogMainOverride"
            }}
          >
            <div className="ms-Grid">
              <div className="ms-Grid-col ms-sm6">
                <ChoiceGroup options={this.state.optionsType} selectedKey={this.state.selType} onChange={(ev,option)=>{this.setState({selType:option.key,selClassID:"",selStudentID:"",selStudentName:""})}} />
                <Dropdown label="Velg klasse" selectedKey={this.state.selClassID} options={this.state.optionsClasses} onChange={(ev,option)=>{this.setState({selClassID:option.key.toString()},()=>{this.getStudentsForClass(option.key.toString())})}} />
                {this.state.selType === "STUDENT" && (
                  <Dropdown label="Velg elev" selectedKey={this.state.selStudentID} disabled={!this.state.selClassID || this.state.isLoadingStudents} options={this.state.optionsStudents} onChange={(ev,option)=>{this.setState({selStudentID:option.key.toString(),selStudentName:option.text})}} />
                )}
              </div>

            </div>
            <DialogFooter>
              <DefaultButton
                onClick={this.props.onDialogDismiss}
                text="Avbryt"
              />
              {this.props.dialogTitle === "Skriv ut" && (
                <a
                  href={`${window.location.origin}/#/ukeplan/printview?week=${this.props.selWeek}&year=${this.props.selYear}&classid=${this.state.selClassID}&studentid=${this.state.selStudentID}&studentname=${this.state.selStudentName}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <PrimaryButton
                    onClick={() => {
                      //window.open(window.location.href + "/printview" + "?week=" + this.props.selWeek + "&year=" + this.props.selYear + "&classid=" + this.state.selClassID + "&studentid=" + this.state.selStudentID + "&studentname=" + this.state.selStudentName);
                      this.props.onDialogDismiss();
                    }}
                    text={`Generer utskrift for ${this.state.selType==="STUDENT" ? "elev": "klasse"}`}
                    disabled={(this.state.selType === "STUDENT" && !this.state.selStudentID) || !this.state.selClassID}
                  />
                </a>
              )}
              {this.props.dialogTitle === "Skriv ut" && this.state.selType === "CLASS" && (
                <a
                  href={`${window.location.origin}/#/ukeplan/printview?week=${this.props.selWeek}&year=${this.props.selYear}&classid=${this.state.selClassID}&printFor=teacher`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <PrimaryButton
                    onClick={() => {
                      //window.open(window.location.href + "/printview" + "?week=" + this.props.selWeek + "&year=" + this.props.selYear + "&classid=" + this.state.selClassID + "&printFor=teacher");
                      this.props.onDialogDismiss();
                    }}
                    text={`Generer lærerutskrift`}
                    disabled={!this.state.selClassID}
                  />
                </a>
              )}
              {this.props.dialogTitle === "Send på e-post" && (
                <a 
                  href={`${window.location.origin}/#/ukeplan/send?week=${this.props.selWeek}&year=${this.props.selYear}&classid=${this.state.selClassID}&studentid=${this.state.selStudentID}&studentname=${this.state.selStudentName}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <PrimaryButton
                    onClick={async () => {
                      // await axios.get(`${ROOT_URL}/GetUkeplanForClass?classId=${this.state.selClassID}&week=${this.props.selWeek}&year=${this.props.selYear}`, {
                      //     headers: {
                      //         Authorization: localStorage.getItem('id_token'),
                      //     },
                      // })
                      this.props.onDialogDismiss();
                    }}
                    text={`Hent adresser for ${this.state.selType==="STUDENT" ? "elev": "klasse"}`}
                    disabled={(this.state.selType === "STUDENT" && !this.state.selStudentID) || !this.state.selClassID}
                  />
                </a>
              )}
              
            </DialogFooter>
          </Dialog>
      )
    }
  }

  function mapStateToProps(state) {
    return {
      teacherstate: state.teacher
    };
  }

  export default connect(mapStateToProps)(ClassStudentSelector);